// Javascipt

function initFormButs(container) {

    const formButs = container.querySelectorAll('.but-form');

    formButs.forEach(function(formBut){

        formBut.addEventListener('click', function(e){

            e.preventDefault();

            const formTyp  = this.dataset.formTyp;
           
     

            if (formTyp === 'career') {

                const posttId = this.dataset.postId
                const standortId = this.dataset.standortId;
                
                formModal.loadModal(formTyp, posttId, standortId);
            }

            if (formTyp === 'contact') {

                const standortId = this.dataset.standortId;
                formModal.loadModal(formTyp, false, standortId); 
            }

            if (formTyp === 'purchasing') {
                
                const standortId = this.dataset.standortId;
                const mailTo = this.dataset.mailTo;

                formModal.loadModal(formTyp, false, standortId);
            }

        });

    });  

}
